import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import { useState } from 'react'
import { selectCurrentContractActive } from '../../../SubscriptionForm/SubscriptionFormSelectors'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import * as Sentry from '@sentry/react'

const useChangeUser = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isAdmin } = useSelector(selectAuthData)
  const { type, id } = useRetrieveActiveContractIdAndType()
  const { createdById = null } = useSelector(selectCurrentContractActive) || {}
  const canShowChangeUser = isAdmin && ['Energy', 'Telecom', 'Insurance'].includes(type)
  const [ableChangeUser, setAbleChangeUser] = useState(false)
  const [users, setUsers] = useState([])
  const [userIdSelected, setUserIdSelected] = useState(createdById)

  const changeUserOwner = () => {
    const saveConfirm = confirm('Are you sure?')
    if (!saveConfirm) {
      return
    }

    dispatch({
      type: subscriptionFormActionsV2.PROCESS_CHANGE_USER_V2,
      contractId: id,
      userId: userIdSelected,
      callback: () => {
        setAbleChangeUser(false)
        alert('User changed successfully.')
      },
    })
  }

  const importUserCallback = (response, statusCode) => {
    if (statusCode === 200 && response && response.length > 0) {
      setUsers(response)
      setAbleChangeUser(!ableChangeUser)
    } else {
      if (import.meta.env.PROD && statusCode !== 422) {
        Sentry.captureException(new Error('Load users for change user feature failed'), {
          extra: { response, statusCode },
        })
      }
    }
  }

  const importUsers = () => {
    if (users.length > 0 && !ableChangeUser) {
      setAbleChangeUser(!ableChangeUser)
      return
    }
    dispatch({
      type: subscriptionFormActionsV2.LOAD_USERS_V2,
      callback: importUserCallback,
    })
  }

  return {
    t,
    canShowChangeUser,
    ableChangeUser,
    users,
    userIdSelected,
    createdById,
    setUserIdSelected,
    setAbleChangeUser,
    changeUserOwner,
    importUsers,
  }
}
export default useChangeUser
